<template>
  <svg
    class="search-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  ><path
    fill="#666666"
    d="M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z"
  /><path
    fill="none"
    d="M0,0H24V24H0Z"
  /></svg>
</template>

<script>
export default {
  name: 'SearchIcon'
}
</script>

<style scoped lang="scss">
.search-icon{
  position: absolute;
  left: 0.65rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
</style>
